import { string } from 'yup';

import { containsRestrictedPathChars } from '~/utils/FileUtils';

export const WORKSPACE_NAME_MAX_LENGTH = 65;
export const ITEM_NAME_MAX_LENGTH = 255;

export const ItemNameValidation = string()
  .trim()
  .max(ITEM_NAME_MAX_LENGTH, `Name cannot be longer than ${ITEM_NAME_MAX_LENGTH} characters`)
  .test(
    'restricted-char-validation',
    'Characters : and | cannot be used',
    (val) => !containsRestrictedPathChars(val || ''),
  )
  .matches(/^[^\n]*$/, 'No line breaks allowed')
  .required('Name is required');

export const ClipTitleValidation = string()
  .trim()
  .test(
    'restricted-char-validation',
    'Characters : and | cannot be used',
    (val) => !containsRestrictedPathChars(val || ''),
  )
  .required('Clip name is required')
  .default('');
